function eventListenerFactory(eventName) {
  function directiveDeclaration($parse) {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        const eventHandler = $parse(attrs[eventName]);
        scope.$on(eventName, () => eventHandler(scope));
      }
    };
  }

  directiveDeclaration.$inject = ['$parse'];

  return directiveDeclaration;
}

module.exports = eventListenerFactory;
